
import Vue, { PropType } from 'vue'
import { Project } from '@/model/Project'
import { Multimedia } from '@/model/Multimedia'
import { Category } from '@/model/Category'
import { Tag } from '@/model/Tag'
import ProjectDescriptionEditor from '@/components/project/ProjectDescriptionEditor.vue'
import ProjectDetails from '@/components/project/ProjectDetails.vue'
import ProjectFormMultimedia from '@/components/project/ProjectFormMultimedia.vue'
import AddImageDialog from '@/components/project/AddImageDialog.vue'
import AddMovieDialog from '@/components/project/AddMovieDialog.vue'
import PagedResults from '@/service/PagedResults'

export default Vue.extend({
  name: 'ProjectForm',

  components: {
    ProjectDescriptionEditor,
    ProjectDetails,
    ProjectFormMultimedia,
    AddImageDialog,
    AddMovieDialog,
  },

  props: {
    value: {
      type: Object as PropType<Project>,
    },
    publishLoading: {
      type: Boolean,
    },
  },

  mounted() {
    const apiPromises = []
    const allCategories = new PagedResults<Category[]>(this.$api)
    const allTags = new PagedResults<Tag[]>(this.$api)

    apiPromises.push(
      allCategories
        .all('/categories', 30)
        .then((response) => {
          this.categories = response
        })
        .catch((e) => {
              this.$store.dispatch(
                  'alert/error',
                  'Problems with reading project categories.'
              )
            }
        )
    )

    apiPromises.push(
      allTags
        .all('/tags', 30)
        .then((response) => (this.tags = response))
    )

    Promise.allSettled(apiPromises)
      .catch(() =>
        this.$store.dispatch(
          'alert/error',
          'Problem with reading API for project.'
        )
      )
      .finally(() => {
        if(this.value?.category){
          this.selectedCategory = this.value.category
        } else if (this.value.categories && this.value.categories[0]){
          this.selectedTags = this.value.categories[0]
        }

        this.updateTags()
      })

    // if(this.value?.assets.length > 0){
    //   const main = this.value.assets.find((a) => a.id == this.value?.mainImage as string)
    //
    //   if(main){
    //     this.value.mainImage = main
    //   }
    // }
  },

  data: () => ({
    startDateDialog: false,
    addImageDialog: false,
    addMovieDialog: false,
    selectedCategory: {} as Category,
    categories: [] as Category[],
    tags: [] as Tag[],
    selectedTags: [] as Tag[],
    step: 1,
    step1Valid: false,
    nameRules: [(v: string) => !!v || "Name value can't be empty."],
    categoryRules: [(v: Category) => !!v.name || "Category must be select from the list."],
    startAtRules: [(v: string) => !!v || "Project start date can't be empty."],
    onlyEnglishAlert: 'Please remember to use english only',
    descriptionCharactersCount: 0,
    abstractDescriptionCharactersCount: 0
  }),

  methods: {
    gotoStep2: function () {
      if (!(this.$refs.step1Form as any).validate()) {
        this.$store.dispatch(
          'alert/error',
          'There are some errors in the form.'
        )

        return
      }

      if (this.value.assets.length === 0) {
        this.$store.dispatch(
          'alert/error',
          'Add at least one image to the project.'
        )

        return
      }

      if (!this.value.mainImage) {
        this.$store.dispatch(
          'alert/error',
          'One image have to be set as cover image.'
        )

        return
      }

      this.value.category ? this.value.category = this.selectedCategory.id : this.value.category = this.selectedCategory.id

      const mappedTags = this.selectedTags.map((tag) => {
        if (typeof tag === 'object' && tag !== null) {
          return {
            id: tag.id || null,
            name: tag.name
          };
        }

        return {
          id: null,
          name: tag
        };
      });

      this.value.tags = mappedTags;

      this.step = 2
    },

    gotoStep3: function () {
      if (!this.value.description) {
        this.$store.dispatch(
          'alert/error',
          'Abstract description for the project is required.'
        )

        return
      }

      if (this.abstractDescriptionCharactersCount >= 1500) {
        this.$store.dispatch(
          'alert/error',
          'Abstract description can be maximum 1500 long.'
        )

        return
      }

      if (this.descriptionCharactersCount < 1000) {
        this.$store.dispatch(
          'alert/error',
          'Detailed informations for the project are required and should be at least 1000 characters long.'
        )

        return
      }

      (this.$refs.projectDetailsRef as any).fetchProject()
      this.step = 3
    },

    updateTags: function () {
      this.selectedTags = this.value.tags
    },

    deleteMedia: function (media: Multimedia) {
      if (media.id === (this.value.mainImage as Multimedia).id) {
        this.$store.dispatch(
          'alert/warning',
          'You must select new cover image first.'
        )

        return
      }

      const projectMultimedia = this.value.assets as Multimedia[]
      projectMultimedia.splice(projectMultimedia.indexOf(media), 1)
    },

    changeCoverImage: function (media: Multimedia) {
      this.value.mainImage = media
    },

    addUploadedImages: function (multimedia: Multimedia[]) {
      const projectMultimedia = this.value.assets as Multimedia[]
      this.value.assets = [...projectMultimedia, ...multimedia]

      if (!this.value.mainImage) {
        this.changeCoverImage(multimedia[0])
      }
    },

    addYoutubeMovie: function (multimedia: Multimedia) {
      (this.value.assets as Multimedia[]).push(multimedia)
    },
  },

  watch: {
    'value.tags': function () {
      this.updateTags()
    },
  },
})
